/// <reference types="vite/client" />

interface ImportMetaEnv {
  readonly VITE_BACKEND_URL?: string;
}

interface ImportMeta {
  readonly env: ImportMetaEnv;
}

declare const __APP_VERSION__: string;

const env: ImportMetaEnv = (import.meta as unknown as ImportMeta).env;

export const BACKEND_URL: string =
  env.VITE_BACKEND_URL ?? "https://tgpe-miniapp-bot.giglabo.com";

export const APP_VERSION: string = __APP_VERSION__;
